import { topicTags } from '@/mocks/homeData';

const colorClasses: Record<string, { bg: string; text: string }> = {
  accent: { bg: 'bg-accent-100', text: 'text-accent-800' },
  primary: { bg: 'bg-primary-100', text: 'text-primary-700' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">影迷们正在热烈讨论的电影话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicTags.map((tag) => {
            const colors = colorClasses[tag.color] || colorClasses.accent;
            return (
              <div key={tag.id} className={`flex items-center gap-2 px-4 py-2.5 rounded-full ${colors.bg} cursor-pointer transition-all hover:scale-105`}>
                <span className={`text-sm font-medium ${colors.text} whitespace-nowrap`}>#{tag.name}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{tag.heat}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}